import { render, staticRenderFns } from "./Question5.vue?vue&type=template&id=c9c42978"
import script from "./Question5.vue?vue&type=script&lang=js"
export * from "./Question5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports